import { styled } from '@mui/material/styles';

export const Container = styled('div')`
  width: 80vw;
  max-width: 90vh;
  display: flex;
  flex-direction: column;
`;
